import React from "react";

export default () => (
  <svg width="14" height="14" viewBox="0 0 14 14">
    <path d="M5.14079 9.248L2.72191 6.82911L1.89746 7.65355L5.14079 10.8891L12.1019 3.92799L11.2775 3.11133L5.14079 9.248Z" fill="#2DC57C" />
  </svg>
);
